import * as React from 'react';
import { components } from 'react-select';

const ClearFilterIndicatorRenderer = (props: any) => {
	return (
		<components.ClearIndicator
			{...props}
			innerProps={{
				...props.innerProps,
				'data-test': 'applyFiltersClearSelectedFilter',
			}}
		/>
	);
};

export default ClearFilterIndicatorRenderer;
